<template>
  <div>
    <div class="mb-4 flex flex-col">
      <span>points to be issued instantly</span>
      <input
        class="item-name-input"
        data-cy="instant-points-name-input"
        min="0"
        step="1"
        type="number"
        :class="{ error: isBonusValueEmptyOrLessThan1 }"
        v-model.number="instantPointsDraftState.bonus_value"
      />
    </div>

    <div class="mb-4 flex items-center">
      <checkbox
        :checked.sync="instantPointsDraftState.apply_to_non_opt_in"
        class="h-5 w-5 flex-none"
        id="applyToNonOptIn"
      />
      <label class="leading-4 pl-1.5" for="applyToNonOptIn">
        issue instant point offer to members who would qualify for this message but are not opted in (member offer)
      </label>
    </div>
  </div>
</template>

<script>
import { Checkbox } from "@springbig/sb-components";

export default {
  name: "instant-points-form",

  components: {Checkbox},

  props: {
    instantPointsDraftState: Object
  },

  computed: {
    isBonusValueEmptyOrLessThan1(){
      return !this.instantPointsDraftState?.bonus_value ||
             this.instantPointsDraftState.bonus_value < 1;
    },
  }
}
</script>
